import { event } from 'jquery'
import * as factory from '../../../iawp/src/js/factory'
import './form'

new factory.IAInit()

document.querySelectorAll('.ia-block-dropdown').forEach((dropdown)=>{
    new factory.IADropdown(
        dropdown.querySelector('.ia-block-dropdown-toggle'), 
        dropdown.querySelector('.ia-block-dropdown-content')
    )
})

document.querySelectorAll('.menu-item-has-children button').forEach(menuButton => {
    menuButton.previousElementSibling.addEventListener('click', e => {
        e.preventDefault()
        menuButton.parentElement.classList.toggle('active')
    })
    menuButton.addEventListener('click', e => {
        e.preventDefault()
        menuButton.parentElement.classList.toggle('active')
    })
})

window.onresize = function(){
    checkSize();
}
checkSize();
function checkSize() {
    if(window.matchMedia("(max-width: 1024px)").matches) {
        document.querySelector('.ia-block-pre-header').setAttribute('aria-visible', 'hidden')
        document.querySelector('.ia-block-pre-header').style.display = "none"
    }else {
        document.querySelector('.ia-block-pre-header').setAttribute('aria-visible', 'visible')
        document.querySelector('.ia-block-pre-header').style.display = "block"
    }
}
if (!!document.querySelector('.ia-block-page')) {
    document.querySelectorAll('.ia-block-page').forEach(block => {
        let bgColor = block.style.backgroundColor
        block.querySelector('.wp-block-button__link').style.setProperty('color',bgColor, 'important')
    })
}

if (!!document.querySelector('.wp-block-gallery.is-style-square-slider')) {
    document.querySelectorAll('.wp-block-gallery.is-style-square-slider').forEach(block => {
        let blockClasses = block.classList

        // Cleaning block classes
        block.classList.remove(...blockClasses)
        block.classList.add('wp-block-gallery', 'is-style-square-slider')

        // Cleaning image classes
        block.querySelectorAll('.wp-block-image').forEach(el => {
            let elClasses = el.classList
            el.classList.remove(...elClasses)
            el.classList.add('wp-block-image', 'swiper-slide')
        })

        let galleryContent = block.innerHTML
        let $swiperWrapper = document.createElement('div')
        let $swiperPagination

        if (block.querySelectorAll('.wp-block-image').length > 1) {
            $swiperPagination = document.createElement('div')
            $swiperPagination.classList.add('swiper-pagination')
        }
        
        $swiperWrapper.classList.add('swiper-wrapper')
        $swiperWrapper.innerHTML = galleryContent

        block.innerHTML = ''
        block.appendChild($swiperWrapper)
        if ($swiperPagination !== undefined) {
            block.appendChild($swiperPagination)
        } 
        block.classList.add('swiper-container')

        let $swiper = new factory.IASwiper(block, {
            itemPerSlide: 1,
            autoplay: 3000,
        })
    })
}

document.querySelectorAll('.ia-block-quicksearch').forEach((quicksearch)=>{

    let quicksearchToggle = quicksearch.querySelector('.ia-block-quicksearch-toggle')
    let quicksearchTarget = quicksearch.querySelector('.ia-block-quicksearch-content')

    quicksearchToggle.addEventListener('click', (e) => {
        if (quicksearchTarget === undefined || quicksearchTarget === null) {
            // check if toggler has a data-target or data-toggle attribute
            quicksearchTarget = quicksearchToggle.getAttribute('data-target') || quicksearchToggle.getAttribute('data-toggle');
            if (quicksearchTarget === null) {
                quicksearchTarget = e.target.nextElementSibling
            }
        }
    
        if (quicksearchTarget !== null) {
            //$(quicksearchTarget).slideToggle()
            quicksearchTarget.classList.toggle('active')
            quicksearch.classList.toggle('open')
            let classes = (quicksearchTarget.classList.contains("active"))?'fas fa-angle-right':'fas fa-search'
            setTimeout(() => {
                quicksearchToggle.querySelector('i').setAttribute('class', classes)
            }, 50);
        }
    })

})


if(!!document.querySelector('.ia-block-bank')){
    document.querySelector('.ia-block-bank select').addEventListener('change', function(e){
        document.querySelector('.ia-block-bank__selected').textContent = e.target.value
    })
}

if (!!document.querySelector('.wp-block-cover.is-style-animated-banner')) {
    
    console.log(document.querySelector('.section-default-inner').firstElementChild)
    if (document.querySelector('.section-default-inner').firstElementChild.classList.contains('is-style-animated-banner')) {
        document.querySelector('.section-default-inner').classList.add('hacked-paddings')
    }
}

document.addEventListener('click', (event) => {
    let activeSubmenu = document.querySelector('.section-header .ia-block-navigation__content .menu-item-has-children.active')
    if (!!activeSubmenu) {
        if (!activeSubmenu.contains(event.target)) {
            activeSubmenu.classList.remove('active')
        }
    }
})

if (!!document.querySelector('.ia-block-catalogues__list__item')) {
    document.querySelectorAll('.ia-block-catalogues__list__item').forEach(item => {
        item.addEventListener('mouseenter', function(e) {
            item.classList.add('hover')
        })

        item.addEventListener('mouseleave', function(e) {
            item.classList.remove('hover')
        })
    })
}

factory.$(document).on('click','a[href^="#"]', function(event) {
    var $header = factory.$('.section-header')
    var target = factory.$(this).attr('href');
    
    if (target !== undefined && target.length > 0 && target[0] === '#') {
        factory.$('html, body').animate({
            scrollTop: factory.$(target).offset().top - ($header.outerHeight() + 40)
        }, 1000);
    }
});
/*
var smoothScroll = function() {
    $(document).on('click', '[data-scroll]', function(event) {

        if ($('body').hasClass('no-scroll')) {
            $('#section-header-mobilenav-close').trigger('click');
        }
        var header = $('.section-header.is-fixed');
        var target = $(this).attr('href');
        if (target !== undefined && target.length > 0 && target[0] == '#') {
            $('html, body').animate({
                scrollTop: $(target).offset().top - header.outerHeight()
            }, 1000);
        } 
    });
}
*/

//Block newsletter captcha
if(!!document.querySelector('.ia-block-sarbacane')) {

    const inputEmail = document.getElementById('input-email-block');
    const divElement = document.getElementById('ia-block-captcha-block');
    
    inputEmail.addEventListener('input', (e) => {
        if(e.target.value.length !== 0) {
            divElement.classList.remove('hidden');
        } else {
            divElement.classList.add('hidden');
        }
    });
}

//Footer newsletter captcha
const footerElement = document.getElementById('ia-block-captcha-footer');
const footerEmail = document.getElementById('input-email-footer');

footerEmail.addEventListener('input', (e) => {
    if(e.target.value.length !== 0) {
        footerElement.classList.remove('hidden');
    } else {
        footerElement.classList.add('hidden');
    }
});

//Contact form captcha
const contactEmail = document.getElementById('ia-block-captcha-block');
document.querySelectorAll('.js-ia-blocks-form input[type="text"], textarea').forEach(
    input=>{
        input.addEventListener('input', function(){
            let arrayValue = [];
            document.querySelectorAll('.js-ia-blocks-form input[type="text"], textarea').forEach(
                i=> {
                    arrayValue.push(i.value);    
                }
            )

            const checkArrayValue = arrayValue.includes(''); 

            if(checkArrayValue) { //si tous les champs ne sont pas remplis
                contactEmail.classList.add('hidden');
            } else {
                contactEmail.classList.remove('hidden');
            }
        })
    }
)
